import React from 'react';
import { useBreakpoint, useHover } from '@landr/maestro';
import {
    ContentSuggestionPayload,
    SuggestionsType,
} from 'components/Filters/context/SearchBarContext/types';
import useDeleteUserRecentSearch from 'apollo/userRecentSearch/useDeleteUserRecentSearch';
import { useAuthentication } from 'components/AuthenticationProvider/AuthenticationProvider';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import { useCreateUserRecentSearch } from 'apollo/userRecentSearch/useCreateUserRecentSearch';
import useContentSuggestionItem from '../hooks/useContentSuggestionItem';
import SuggestionGeneric from './SuggestionGeneric';

export const ContentSuggestionItem = ({
    modifiers,
    suggestionType,
    isSelected,
}: {
    modifiers: ContentSuggestionPayload;
    suggestionType: SuggestionsType;
    isSelected: boolean;
}) => {
    const [hoverRef, isHovered] = useHover(false);
    const isModal = useBreakpoint('md');

    const { applySuggestion } = useSearchBarContext();
    const { isAuthenticated } = useAuthentication();

    const createUserRecentSearch = useCreateUserRecentSearch({
        isAuthenticated,
    });
    const deleteUserRecentSearch = useDeleteUserRecentSearch({
        isAuthenticated,
    });

    const {
        filterName,
        icon,
        isNavigationItem,
        isRemoveSuggestionVisible,
        filterCategories,
        handleClick,
        handleRemoveRecentSuggestion,
    } = useContentSuggestionItem({
        isHovered,
        modifiers,
        suggestionType,
        applySuggestion,
        createUserRecentSearch,
        deleteUserRecentSearch,
    });

    if (!filterName) {
        return null;
    }

    return (
        <SuggestionGeneric
            hoverRef={hoverRef}
            filterName={filterName}
            filterCategories={filterCategories}
            handleClick={handleClick}
            handleRemoveRecentSuggestion={handleRemoveRecentSuggestion}
            isRemoveSuggestionVisible={isRemoveSuggestionVisible}
            icon={icon}
            isModal={isModal}
            isSelected={isSelected}
            isNavigationItem={isNavigationItem}
        />
    );
};
